<template>
    <div>
        <div class="form-group p-0-14">
            <div class="enum-attribute" v-if="attribute">
                <label class="attribute-label" :for="id">{{ attribute.attribute_name }}</label>
                <ul>
                    <li v-for="(value,index) of attribute.attribute_values" :key="index" @click="onClick(value)"
                        :class="[{'selected':value && selected && value.attribute_value_id == selected.attribute_value_id } ,'new-inputs']">

                        <span class="attribute-value">
                            {{ value.attribute_value }}
                        </span>

                        <!-- :TODO replace the height of the input if price doesn't exist -->
                        <span class="cost-attribute" style="text-align: left;">
                            $30.00 per hour
                        </span>
                    </li>
                </ul>
            </div>
            <div v-if="selected && selected.hasOwnProperty('attribute_value_id')" class="display-none">
                <input type="radio" :name="name" :id="`${id}-${selected.attribute_value_id}`"  :value="selected.attribute_value_id">
            </div>
            <image-uploader v-if="question.show_answer_photo" :question="question"></image-uploader>
        </div>
    </div>
</template>

<script>

import {EventBus} from "@/events/event-bus";

export default {
    name: "EnumAttribute",
    props: {
        value: {},
        dateFormat: null,
        timeFormat: null,
        clone: 0
    },
    data() {
        return {
            selected: {}
        }
    },
    computed: {
        /**
         * gets all dependencies of the selected attribute
         * @returns {T[]|*[]}
         */
        /**
         * get attribute input id
         * @returns {string}
         */
        id() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}`;
            }
            return `question_${this.input.question_id}`;
            // return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}_${this.clone}`;
        },
        /**
         * get attribute input name
         * @returns {string}
         */
        name() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}`;
            }
            return `question_${this.input.question_id}`;
            // return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}_${this.clone}[]`;
        }
    },
    methods: {
        /**
         * pick a value
         * @param value
         */
        onClick(value) {
            this.selected = value
            this.$emit('input', this.selected);

        }
    }
}
</script>

<style scoped>
.display-none {
    display: none;
}
</style>